module.exports = __webpack_public_path__ + "static/media/merriweather-regular-webfont.479fc84c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-regular-webfont.ttf
// module id = 289
// module chunks = 0